import type {FeatureData} from './catalog';

const COMMON_LANGUAGE = 'common';
const CHOSEN_LANGUAGES_COUNT = 2;

export const LANGUAGES_FEATURE_ID = 'languages';

export const createLanguagesFeature = (): FeatureData => ({
	id: LANGUAGES_FEATURE_ID,
	title: 'Языки',
	description: 'Вы знаете Всеобщий язык и ещё два языка по вашему выбору из таблицы стандартных языков.',
	levels: [1],
	order: -1,
	props: {languages: [COMMON_LANGUAGE]},
	choose: [
		{
			key: 'standard-languages',
			type: 'language',
			label: 'Стандартные языки',
			max: CHOSEN_LANGUAGES_COUNT,
			multiple: true,
			params: {},
			filters: {language: ['standard']},
		},
	],
});
